import React, { useState } from "react";

// import JS files

// import others files

const SupporterCard = (props) => {
  return (
    <>
      <div className="col-span-10 md:col-span-2 rounded-xl bg-mygrays-100 flex flex-col items-center p-4">
        <div>
          <img src={props.logo} className="w-24 h-24" />
        </div>
        <div className="border-t border-white w-full mt-4 pt-2 flex justify-center">
          <span className="font-bold text-myblacks-300">{props.name}</span>
        </div>
      </div>
    </>
  );
};

export default SupporterCard;
